import { Component, Input, OnChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserProfileService } from '../../service/user-profile.service';
import { Skill } from '../../interface/user-profile';

@Component({
  selector: 'app-profile-skills',
  templateUrl: './profile-skills.component.html',
  styleUrls: ['./profile-skills.component.css'],
})
export class ProfileSkillsComponent implements OnChanges {
  @Input() skills: Skill[] | null = [];
  @Input() mode: 'view' | 'edit' = 'view';

  isModalOpen = false;
  isEditing = false;
  editingIndex = -1;
  isSaving = false;
  skillForm!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private userProfileService: UserProfileService,
  ) {}

  ngOnChanges(): void {}

  initForm(skill?: Skill): void {
    this.skillForm = this.fb.group({
      skill: [skill?.skill || '', Validators.required],
      percentage: [
        skill?.percentage || 50,
        [Validators.required, Validators.min(0), Validators.max(100)],
      ],
    });
  }

  openAddModal(): void {
    this.isEditing = false;
    this.editingIndex = -1;
    this.initForm();
    this.isModalOpen = true;
  }

  openEditModal(skill: Skill, index: number): void {
    this.isEditing = true;
    this.editingIndex = index;
    this.initForm(skill);
    this.isModalOpen = true;
  }

  closeModal(): void {
    this.isModalOpen = false;
  }

  saveSkill(): void {
    if (!this.skillForm.valid) {
      this.skillForm.markAllAsTouched();
      return;
    }

    this.isSaving = true;
    const formValue = this.skillForm.value;

    // Build updated list
    const updatedList: Skill[] = [...(this.skills || [])];
    const newSkill: Skill = {
      skill: formValue.skill,
      percentage: formValue.percentage,
    };

    if (this.isEditing && this.editingIndex >= 0) {
      updatedList[this.editingIndex] = newSkill;
    } else {
      updatedList.push(newSkill);
    }

    // Send as skillsJson (consistent with experiences and educations)
    const formData = new FormData();
    formData.append('skills', JSON.stringify(updatedList));

    this.userProfileService.updateUserProfile(formData).subscribe({
      next: (response) => {
        this.isSaving = false;
        this.skills = response.skills ?? updatedList;
        this.closeModal();
      },
      error: (error) => {
        this.isSaving = false;
        console.error('Error updating skills:', error);
        alert('Failed to update. Please try again.');
      },
    });
  }

  deleteSkill(index: number): void {
    if (!confirm('Remove this skill?')) return;

    const updatedList = (this.skills || []).filter((_, i) => i !== index);
    const formData = new FormData();
    formData.append('skills', JSON.stringify(updatedList));

    this.userProfileService.updateUserProfile(formData).subscribe({
      next: (response) => {
        this.skills = response.skills ?? updatedList;
      },
      error: (error) => {
        console.error('Error deleting skill:', error);
        alert('Failed to delete. Please try again.');
      },
    });
  }
}
